<ng-container (window:resize)="onResize($event)">
  <app-product-slideshow-specials
    [nombre]="nombre"
    [grid]="innerWidth < 1025 ? 'grid-4-full' : 'grid-4-full'"
  />
</ng-container>
